/* eslint-disable no-console -- Centralized logging adapter. */

const getConsole = () => (typeof console !== 'undefined' ? console : null);

export const logError = (message, ...args) => {
  try {
    const logger = getConsole();
    if (typeof logger?.error !== 'function') {
      return false;
    }

    logger.error(message, ...args);
    return true;
  } catch {
    return false;
  }
};
